import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LayoutModule } from '../../layout/layout.module';
import { RegisterComponent } from '../register/register.component';
import { RegisterCommonComponent } from '../register-common/register-common.component';
import { RegisterCarrierComponent } from '../register-carrier/register-carrier.component';
import { RegisterCarrierFinishComponent } from '../register-carrier-finish/register-carrier-finish.component';
import { RegisterCarrierFinalStepComponent } from '../register-carrier-final-step/register-carrier-final-step.component';
import { RegisterCarrierInviteComponent } from '../register-carrier-invite/register-carrier-invite.component';
import { ChangesCarrierInviteComponent } from '../register-carrier-changes/changes-carrier-invite.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';

@NgModule({
  declarations: [
    RegisterComponent,
    RegisterCommonComponent,
    RegisterCarrierComponent,
    RegisterCarrierFinishComponent,
    RegisterCarrierFinalStepComponent,
    RegisterCarrierInviteComponent,
    ChangesCarrierInviteComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
  ],
  imports: [
    CommonModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTooltipModule,
  ],
  exports: [
    RegisterComponent,
    RegisterCommonComponent,
    RegisterCarrierComponent,
    RegisterCarrierFinishComponent,
    RegisterCarrierFinalStepComponent,
    RegisterCarrierInviteComponent,
    ChangesCarrierInviteComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
  ],
})
export class RegisterModule { }
